<template>
  <div class="resultDiv" v-loading="loading">
    <table>
      <thead>
        <tr>
          <th>暴涨词</th>
          <th>流量指数</th>
          <th>移动指数</th>
          <th>360指数</th>
        </tr>
      </thead>
      <tbody id="soaringWords" :style="{ overflow: yShow }">
        <tr v-for="(item, index) in getData" :key="index">
          <td
            :class="[
              item.indexNum === 1
                ? 'top1'
                : item.indexNum === 2
                ? 'top2'
                : item.indexNum === 3
                ? 'top3'
                : ''
            ]"
            @click="SearchWords(item.keyword)"
          >
            <span>{{ item.indexNum }}</span
            >{{ escape2Html(item.keyword) }}
          </td>
          <td>
            <div>
              {{ item.pcIndex }}
            </div>
            <div>
              <i :class="[item.pcIndexPer > 0 ? 'icons up' : 'icons down']"></i
              >{{ item.pcIndexPer }}%
            </div>
          </td>
          <td>{{ item.mobleIndex }}</td>
          <td>{{ item.hsIndex > 0 ? item.hsIndex : "--" }}</td>
        </tr>
      </tbody>
      <shieldUpgrade
        v-if="userLevel < 6 || userLevel === ''"
        class="shieldBox"
        :style="{
          top: showtop + 'px',
          height: 'calc(100% - ' + showheight + 'px)'
        }"
      ></shieldUpgrade>
      <div class="page">
        <div class="bottom-left">
          <el-pagination
            ref="pagination"
            background
            layout="prev, pager, next, jumper"
            :total="rowCount"
            :current-page="pageable.pageIndex"
            :page-size="pageable.pageSize"
            :pager-count="5"
            @current-change="goPage"
            hide-on-single-page
          ></el-pagination>
        </div>

        <div class="mr20 bottom-right">
          <span class="lookall">
            <a href="https://www.5118.com/traffichot" target="_blank"
              >更多数据</a
            >
          </span>
        </div>
      </div>
    </table>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { Pageable } from "../../assets/script/model";
import shieldUpgrade from "../dialogs/shieldUpgrade";
export default {
  name: "SoaringWords",
  data() {
    return {
      getData: [],
      loading: false,
      rowCount: 0,
      number: 1,
      showtop: 531,
      showheight: 590,
      yShow: "scroll"
    };
  },
  components: {
    shieldUpgrade
  },
  computed: {
    ...mapState("user", ["userLevel"]),
    contentHeight: {
      get() {
        return this.$store.state.contents.contentHeight;
      }
    },
    pageable: {
      get() {
        return this.$store.state.hotList.Pageable;
      },
      set(val) {
        this.$store.state.hotList.Pageable = val;
      }
    }
  },
  created() {
    this.pageable = new Pageable(1, 30);
    this.getData = [];
    this.number = 1;
    this.getTopData();
  },
  watch: {
    contentHeight: {
      handler(val) {
        this.getHotLineHeight(val, "soaringWords", 60);
      }
    }
  },
  mounted() {
    this.getid = setInterval(() => {
      let getBox = document.getElementById("soaringWords");
      if (getBox) {
        clearInterval(this.getid);
        this.getHotLineHeight(this.contentHeight, "soaringWords", 60);
        // this.getTopData();
        let dom = document.getElementsByTagName("table")[0];
        dom.getElementsByTagName("tbody")[0].style.overflowX = "hidden";
      }
    }, 500);
  },
  methods: {
    ...mapActions("hotList", ["ASoaringWord"]),
    SearchWords(keyword) {
      this.$router.push("/material/article/" + keyword);
    },
    async getTopData() {
      // if (this.pageable.pageIndex > 1) {
      //   this.showtop = 160;
      //   this.showheight = 200;
      //   this.yShow = "scroll";
      // } else {
      //   this.showtop = 531;
      //   this.showheight = 590;
      //   console.log(this.userLevel);
      //   if (this.userLevel < 100) this.yShow = "hidden";
      // }
      this.loading = true;
      this.getData = [];
      let result = await this.ASoaringWord(this.pageable);
      if (result.errorCode === 0) {
        this.rowCount =
          result.data.rowCount >= 300 ? 300 : result.data.rowCount;
        if (this.pageable.pageIndex > 1) {
          this.number =
            (this.pageable.pageIndex - 1) * this.pageable.pageSize + 1;
        } else {
          this.number = 1;
        }
        for (let item of result.data.dataSource) {
          this.getData.push({
            keyword: item.word,
            pcIndex: item.baiduIndex,
            pcIndexPer: item.riseScale,
            hsIndex: item.haoSouIndex,
            mobleIndex: item.mobileIndex,
            indexNum: this.number
          });
          this.number++;
        }
      } else {
        if (result.errorCode === 300000) {
          this.pageable = new Pageable(1, 30);
          this.getData = [];
          this.number = 1;
          this.getTopData();
          this.insertConfig.showLoginMessage(
            true,
            "您当前账号暂未登录，请登录账号享更多权限",
            "articleNextPage"
          );
        } else if (result.errorCode === 300040) {
          this.pageable = new Pageable(1, 30);
          this.getData = [];
          this.number = 1;
          this.getTopData();
          this.insertConfig.showUpgrade(true, "获取翻页权限");
        } else {
          this.$message({
            message: result.errorMess,
            showClose: true,
            type: "error"
          });
        }
      }
      this.loading = false;
    },
    goPage(pageIndex) {
      this.pageable.pageIndex = pageIndex;
      this.getTopData();
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/mixin";
@import "../../assets/style/color";
@import "../../assets/style/config";
.pageIndex();
/deep/.el-pagination__editor.el-input {
  width: 30px;
}
/deep/.el-input__inner {
  width: 28px;
}
/deep/.el-pagination__jump {
  margin-left: 0px;
}
.resultDiv {
  /*padding: 5px 10px;*/
  /*border: 1px solid #d3d7de;*/
  margin: 5px 5px;
  min-height: 150px;
  width: 460px;
  color: #666;
  font-size: 12px;
  .shieldBox {
    position: absolute;
    top: 531px;
    bottom: 0;
    text-align: center;
  }
  .icons {
    display: inline-block;
    height: 15px;
    width: 10px;
    vertical-align: text-bottom;
  }
  .up {
    height: 17px;
    margin-left: 2px;
    background: url("../../assets/image/hot/up.png") no-repeat 50%;
  }
  .down {
    margin-left: 2px;
    background: url("../../assets/image/hot/down.png") no-repeat 50%;
  }
  .lookall {
    border: 1px solid @pcolor;
    padding: 3px 10px;
    border-radius: 15px;
    font-size: 12px;
    line-height: 12px;
    a {
      color: @pcolor;
    }
  }
  .page {
    display: flex;
    justify-content: center;
    align-items: center;
    .bottom-left {
      margin-left: -10px;
    }
    .bottom-right {
      height: 28px;
      line-height: 28px;
      margin-top: 10px;
      margin-right: 0;
    }
  }
}

table tbody {
  display: block;
  height: 500px;
  overflow-y: scroll;
  overscroll-behavior-y: contain;
}
table thead,
tbody tr,
tfoot tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
table thead {
  width: calc(100% - 1em);
}

table {
  width: 100%;
  text-align: left;
  td {
    border: 0;
    display: inline-block;
    .ellipsis();
    &:nth-child(1) {
      width: 35%;
      cursor: pointer;
    }
    &:nth-child(2) {
      width: 35%;
    }
    &:nth-child(3) {
      width: 15%;
    }
    &:nth-child(4) {
      width: 15%;
    }
    span {
      padding-right: 5px;
    }
  }
  th {
    border: 0;
    display: inline-block;
    .ellipsis();
    &:nth-child(1) {
      width: 45%;
      cursor: pointer;
    }
    &:nth-child(2) {
      width: 25%;
    }
    &:nth-child(3) {
      width: 15%;
    }
    &:nth-child(4) {
      width: 15%;
    }
    span {
      padding-right: 5px;
    }
  }
  tbody {
    tr {
      line-height: 30px;
      &:hover {
        background-color: @body-background-color;
      }
      border-bottom: 1px solid @borderbottom;
      td {
        &:nth-child(2) {
          div {
            display: inline-block;
            &:nth-child(1) {
              width: 60px;
              text-align: right;
            }
            &:nth-child(2) {
              margin-left: 7px;
            }
          }
        }
      }
    }
  }
  tbody:before {
    content: "-";
    display: block;
    line-height: 1px;
    color: transparent;
  }
  th {
    font-weight: 500;
    color: #909399;
  }
  .top1 {
    color: red;
  }
  .top2 {
    color: #fea040;
  }
  .top3 {
    color: #167df3;
  }
}
</style>
